/* styleWrappers-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./styleWrappers-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import { DN500 } from '@atlaskit/theme/colors';
export var ARCHIVE_SIDE_BAR_WIDTH = 300;
var archiveItemViewerWrapperStyles = null;
var archiveSideBarStyles = null;
var slideDown = null;
var archiveDownloadButtonWrapperStyles = null;
var disabledArchiveDownloadButtonWrapperStyles = null;
var archiveSidebarFolderWrapperStyles = null;
var sidebarItemWrapperStyles = null;
var archiveSidebarFileEntryWrapperStyles = null;
var archiveLayoutStyles = null;
var archiveViewerWrapperStyles = null;
var separatorStyles = null;
var sidebarHeaderWrapperStyles = null;
var sidebarHeaderIconStyles = null;
var sidebarHeaderEntryStyles = null;
export var ArchiveItemViewerWrapper = function ArchiveItemViewerWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb1osq _1e0c1txw _1bah1h6o"])
  }, children);
};
export var ArchiveSideBar = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: ax(["_ca0qqslr _u5f3v47k _19bvv47k _n3tdv47k _bfhky0hh _kqswstnw _1ltvidpf _154iidpf _1bsb15ov _94n5idpf _vchhusvi _18m915zi"]),
    style: {
      "--_53yrec": ix("".concat(ARCHIVE_SIDE_BAR_WIDTH, "px"))
    }
  }, children);
});
export var ArchiveSidebarFolderWrapper = function ArchiveSidebarFolderWrapper(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "archive-sidebar-folder-wrapper",
    className: ax(["_v564t24z _t9ecz6y5 _tzy4idpf _j7hq1kq8 _5sag188d _1o51q7pw"])
  }, children);
};
export var ArchiveDownloadButtonWrapper = function ArchiveDownloadButtonWrapper(_ref4) {
  var children = _ref4.children,
    onClick = _ref4.onClick;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    "data-testid": "media-archiveDownloadButton",
    className: ax(["_19itglyw _2rkofajl _ca0qu2gc _u5f31v6z _n3td14y2 _19bvu2gc _bfhk1j28 _syazwydc _d0altlke _irr3ebx2 _1qamtlke _1di6j4ot"])
  }, children);
};
export var DisabledArchiveDownloadButtonWrapper = function DisabledArchiveDownloadButtonWrapper(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "media-disabledArchiveDownloadButton",
    className: ax(["_19itglyw _2rkofajl _ca0qu2gc _u5f31v6z _n3td14y2 _19bvu2gc _bfhk1j28 _syazwydc _80om13gf"])
  }, children);
};
export var SidebarItemWrapper = function SidebarItemWrapper(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb13sl"])
  }, children);
};
export var ArchiveSidebarFileEntryWrapper = function ArchiveSidebarFileEntryWrapper(_ref7) {
  var children = _ref7.children,
    index = _ref7.index;
  return /*#__PURE__*/React.createElement("div", {
    key: index,
    className: ax(["_v564rca0 _n3td1vik _1e0c1txw _4cvr1h6o _80omtlke"])
  }, children);
};
export var ArchiveLayout = function ArchiveLayout(_ref8) {
  var children = _ref8.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "archive-layout",
    className: ax(["_1e0c1txw _1bsb1osq _4t3i1osq"])
  }, children);
};
export var ArchiveViewerWrapper = function ArchiveViewerWrapper(_ref9) {
  var children = _ref9.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154iidpf _1ltv15ov _1xi2idpf _94n5idpf _4cvr1h6o _1e0c1txw"]),
    style: {
      "--_53yrec": ix("".concat(ARCHIVE_SIDE_BAR_WIDTH, "px"))
    }
  }, children);
};
export var Separator = function Separator() {
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_2rko1rr0 _4t3iyh40 _19pk1te7 _2hwxidpf _otyr1te7 _18u0idpf _bfhk21we _1o9zidpf"])
  });
};
export var SidebarHeaderWrapper = function SidebarHeaderWrapper(_ref0) {
  var children = _ref0.children;
  return /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c1txw _4cvr1h6o _1o9zidpf"])
  }, children);
};
export var SidebarHeaderIcon = function SidebarHeaderIcon(_ref1) {
  var children = _ref1.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _4cvr1h6o _2hwx1yov _1o9zidpf"])
  }, children);
};
export var SidebarHeaderEntry = function SidebarHeaderEntry(_ref10) {
  var children = _ref10.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1bto1l2s _o5721q9c _vwz41xde _syazrsv4"]),
    style: {
      "--_1k41sl": ix("var(--ds-text, ".concat(DN500, ")"))
    }
  }, children);
};